module.exports = __webpack_public_path__ + "img/carer_info.f7c59ad5.svg";